define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');
	/*
		This model requires one properties to be set: 
			organizationId, which is the organization ID to be set as the default(optional)

		if the organizationId is set to 1, the default will be cleared from all organizations 
		tied to the contact ID and the personal profile will become the default
	*/
  return IpsModel.extend({
	url: function(){
		return '/delegate/civics-api/api/portal/users/organizations/'+ (this.organizationId ? this.organizationId : this.get('organizationId')) + '/default';
	},
	//this model can only update the default. since we don't use an ID, we need to force a put, rather than a post.
	sync:function(method, model, options){
		return Backbone.sync('update', model, options);
	},
	parse: function (response) {
			return response;
		}
  });
});
